var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "color-alpha", on: { "mousedown": function mousedown($event) {
        $event.preventDefault();$event.stopPropagation();return _vm.selectAlpha.apply(null, arguments);
      } } }, [_c('canvas', { ref: "canvasAlpha" }), _vm._v(" "), _c('div', { staticClass: "slide", style: _vm.slideAlphaStyle })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };